import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const cloneViaSigCard = {
  element: '#studio > div.page-content > div.container-fluid > div > div:nth-child(1) > div',
  popover: {
    title: $format('label.TOURS.STUDIO.CLONE.CLONE_SIG_CARD.TITLE'),
    description: $format('label.TOURS.STUDIO.CLONE.CLONE_SIG_CARD.DESCRIPTION'),
    side: 'right',
    align: 'center',
    onNextClick: () => {
      const actionsButton = document.querySelector('.os-icon-more-horizontal');

      if (actionsButton) {
        actionsButton.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
